module.exports = __webpack_public_path__ + "static/media/installation-video-android-EN.a25d0d4f.mp4";